export default __webpack_public_path__ + "static/thumb-landscape-b8d9334b14d2ae5f04ec9b583f85b6f5.jpg";